import React from "react";

import CircleIcon from "@mui/icons-material/FiberManualRecord";
import { Typography } from "@mui/material";

import { LoadingOrValue } from "../LoadingOrValue";

export type Status = "active" | "expired" | "pending" | "initial";

interface Props {
  status: Status;
  statusText?: string;
  error: boolean;
  loading: boolean;
}

export function StatusLabel({ status, statusText, error, loading }: Props) {
  return (
    <Typography
      variant="subtitle1"
      gutterBottom
      sx={(theme) => ({
        ...(status === "initial"
          ? { marginLeft: 0, color: "text.disabled" }
          : { marginLeft: theme.spacing(3) }),
        ...(status === "active" ? { color: "primary.main" } : {}),
        ...(status === "expired" ? { color: "error.main" } : {}),
        ...(status === "pending" ? { color: "secondary.light" } : {}),
      })}>
      <LoadingOrValue
        value={statusText}
        prefix={
          <CircleIcon
            sx={(theme) => ({
              position: "absolute",
              top: theme.spacing(1.6),
              left: theme.spacing(3),
            })}
          />
        }
        loading={loading}
        error={error}
        height={20}
        width={100}
      />
    </Typography>
  );
}
